goog.provide("shadow.js.shim.module$react_use$lib$useDebounce");
goog.provide("module$shadow_js_shim_module$react_use$lib$useDebounce");
shadow.js.shim.module$react_use$lib$useDebounce = shadow.js.nativeProvides["react-use/lib/useDebounce"] = shadow$bridge("react-use/lib/useDebounce");
module$shadow_js_shim_module$react_use$lib$useDebounce.default = shadow.js.shim.module$react_use$lib$useDebounce;
